export const BUCKET_SIZES = {
    FIFTEEN_MINUTES: "15_MIN",
    THIRTY_MINUTES: "30_MIN",
    ONE_HOUR: "60_MIN",
    FOUR_HOURS: "240_MIN",
    TWELVE_HOURS: "720_MIN",
    TWENTY_FOUR_HOURS: "1440_MIN"
};

export const WORK_VIEW_DEFAULT_BUCKET_SIZE = BUCKET_SIZES.TWENTY_FOUR_HOURS;

export const BUCKET_SIZES_IN_MINUTES = new Map([
    [BUCKET_SIZES.FIFTEEN_MINUTES, 15],
    [BUCKET_SIZES.THIRTY_MINUTES, 30],
    [BUCKET_SIZES.ONE_HOUR, 60],
    [BUCKET_SIZES.FOUR_HOURS, 240],
    [BUCKET_SIZES.TWELVE_HOURS, 720],
    [BUCKET_SIZES.TWENTY_FOUR_HOURS, 1440]
]);

export const BUCKET_SIZES_IN_SECONDS = new Map(
    [...BUCKET_SIZES_IN_MINUTES].map(([bucketSize, minutes]) => [bucketSize, minutes * 60])
);
